// Load and initialize all Bootstrap JS
require('bootstrap');

// Load Drift CSS
require('drift-zoom/dist/drift-basic.css');

require('./listing'); // Facet search and sorting
require('./customer'); // Order detail product return form
require('./cart'); // Cart
require('./menumobile');
require('./formbuilder');
require('./order');

// product.js is only loaded in the product page
// so it's not included in theme.js,
// see: webpack.config.js and 
// https://devdocs.prestashop.com/1.7/themes/getting-started/asset-management/

$(document).ready(() => {

    // Nascondi campi non desiderati per indirizzo di spedizone se sei Azienda
    if($('body#checkout input[name="saveAddress"]').val()=="delivery"){
        $("input[name='company']").parent().parent().remove();
        $("input[name='vat_number']").parent().parent().remove();
        $("input[name='dni']").parent().parent().remove();
        $("input[name='address2']").parent().parent().remove();
    }
     // Se cambio nazione non devono cambiare anche i campi del form se sono azienda e indirizzo di spedizione!
     var timeoutAzienda="";
     function cancellaCampiNonRichiestiAziendaSpedizione(){
        if($('body#checkout input[name="saveAddress"]').val()=="delivery"){
            $("input[name='company']").parent().parent().remove();
            $("input[name='vat_number']").parent().parent().remove();
            $("input[name='dni']").parent().parent().remove();
            $("input[name='address2']").parent().parent().remove();
        }
        clearTimeout(timeoutAzienda);
     }
     $('body').on('change','.js-country',function(){
        timeoutAzienda=setTimeout(cancellaCampiNonRichiestiAziendaSpedizione,3000);
     })

     // Vuoi pagare con Paypal e allora non cliccare su Effettua un pagamento!
    $('#payment-option-2').click(function(){
        if($('#payment-option-2-additional-information .paypal-tips').length==1){
            $('#payment-confirmation').fadeOut();
        }
    })

    // Nascondi il codice di riferimento per l'affiliazione!
    $('input[name="sponsorship"]').parent().parent().hide();

    // Se devi mandare un biglietto di auguri almeno scrivi un testo e mettici la firma!!!
    $('ul.cart-overview-list li').each(function(){
        if($(this).data('prod-id')==90){
            $('#customfieldsblock_summary').delay(1000).slideDown();
            $('#procedi-acquisto').click(function(e){
                e.preventDefault();
                var procedi=$(this).attr('href');
                var messaggioAuguri=$('#customfieldsblock_summary textarea').val().length;
                var firmaAuguri=$('#customfieldsblock_summary input[type="text"]').val().length;
                if(firmaAuguri!=0 && messaggioAuguri!=0){
                    window.location.href=(procedi);
                }
                else{
                    alert('Prima di procedere con l\'acquisto compila testo e firma del biglietto di auguri');
                }
            })
        }
    });

    // Distinzione campi iscrizione utente azienda/privato
    if($('#customer-gender').val()==2){
        $("input[name='company']").parent().parent().remove();
        $("input[name='vat_number']").parent().parent().remove();
        $("input[name='address2']").parent().parent().remove();
        $("input[name='dni']").parent().parent().remove();
        $(".choose-sdi-pec").remove();
    }
    $("#delivery-address input[name='company']").parent().parent().remove();
    $("#delivery-address .choose-sdi-pec").remove();
    $("label[for='id_gender'].col-form-label").append('<b class=""> *</b>');
    $("label.required").append('<b class=""> *</b>');
    /* $("label[for='Telefono']").append('<b class=""> *</b>'); */
    $("#invoice-address .address-form-fields label[for='Ragione sociale']").append('<b class=""> *</b>');
    $("#invoice-address .address-form-fields label[for='Partita IVA']").append('<b class=""> *</b>');
    if($('body').hasClass('page-customer-account')){
        $(".address-form-fields label[for='Ragione sociale']").append('<b class=""> *</b>');
        $(".address-form-fields label[for='Partita IVA']").append('<b class=""> *</b>');
    }

     // Se cambio nazione non devono cambiare anche i campi del form!
     var timeout="";
     function cancellaCampiNonRichiesti(){
        var windowWidth=$(window).width();
        if($('#customer-gender').val()==2){
            $("input[name='company']").parent().parent().remove();
            $("input[name='vat_number']").parent().parent().remove();
            $("input[name='address2']").parent().parent().remove();
            $("input[name='dni']").parent().parent().remove();
            $(".choose-sdi-pec").remove();
        }
        $("#delivery-address input[name='company']").parent().parent().remove();
        $("#delivery-address .choose-sdi-pec").remove();
        $("label[for='id_gender'].col-form-label").append('<b class=""> *</b>');
        $("label.required").append('<b class=""> *</b>');
        /* $("label[for='Telefono']").append('<b class=""> *</b>'); */
        $("#invoice-address .address-form-fields label[for='Ragione sociale']").append('<b class=""> *</b>');
        $("#invoice-address .address-form-fields label[for='Partita IVA']").append('<b class=""> *</b>');
        if($('body').hasClass('page-customer-account')){
            $(".address-form-fields label[for='Ragione sociale']").append('<b class=""> *</b>');
            $(".address-form-fields label[for='Partita IVA']").append('<b class=""> *</b>');
        }
        startSDIPECValue();
        clearTimeout(timeout);
     }
     $('body').on('change','.js-country',function(){
        timeout=setTimeout(cancellaCampiNonRichiesti,3000);
     })

     // Sei un gruppo 4 e hai scelto il metodo di spedizione? Allora vedi i prezzi iva inclusa
     if($('#checkout-delivery-step.-current').length==1 || $('#checkout-payment-step.-current').length==1)
     {
         $('.cart-summary-total-label .tax-excl').hide();
         $('.cart-preview-total-label .tax-excl').hide();
     }
     else{
        $('.cart-summary-total-label .tax-excl').css({'display':'inline'});
        $('.cart-preview-total-label .tax-excl').css({'display':'inline'});
     }
     // Nel campo partita IVA si accettano solo numeri!
     var errorIVAAccount=0;
     var errorSDIAccount=0;
     var errorIVAInvoice=0;
     var errorSDIInvoice=0;
     var errorIVADelivery=0;
     var errorSDIDelivery=0;

     /* Check Partita IVA - ACCOUNT */
     function partitaIVAAccount(event) {
        var valueIVAAccount = $('body#address input[name="vat_number"]').val();
        var patternIVAAccount = new RegExp(/^[A-Za-z]{2}\d/i);
        if(patternIVAAccount.test(valueIVAAccount)){
            $('body#address input[name="vat_number"]').removeClass('border').removeClass('border-danger');
            errorIVAAccount=0;
        }else{
            alert("PARTIVA IVA NON CORRRETTA - Inserire la Partita IVA con il seguente formato: IT00000000000");
            $('body#address input[name="vat_number"]').addClass('border border-danger');
            errorIVAAccount=1;
        }
        if(errorIVAAccount || errorSDIAccount){
            $('body#address .address-form .form-submit').prop('disabled',true);
            $('body#address .form-submit').prop('disabled',true);
        }else{
            $('body#address .address-form .form-submit').prop('disabled',false);
            $('body#address .form-submit').prop('disabled',false);
        }
     }     

     /* Check Partita IVA - INDIRIZZO FATTURAZIONE */
     function partitaIVAInvoice(event) {
        var valueIVAInvoice = $('#invoice-address input[name="vat_number"]').val();
        var patternIVAInvoice = new RegExp(/^[A-Za-z]{2}\d/i);
        if(patternIVAInvoice.test(valueIVAInvoice)){
            $('#invoice-address input[name="vat_number"]').removeClass('border').removeClass('border-danger');
            errorIVAInvoice=0;
        }else{
            alert("PARTIVA IVA NON CORRRETTA - Inserire la Partita IVA con il seguente formato: IT00000000000");
            $('#invoice-address input[name="vat_number"]').addClass('border border-danger');
            errorIVAInvoice=1;
        }
        if(errorIVAInvoice || errorSDIInvoice){
            $('#invoice-address .address-form .form-submit').prop('disabled',true);
            $('#invoice-address .form-submit').prop('disabled',true);
        }else{
            $('#invoice-address .address-form .form-submit').prop('disabled',false);
            $('#invoice-address .form-submit').prop('disabled',false);
        }
     }

     /* Check Partita IVA - INDIRIZZO SPEDIZIONE */
     function partitaIVADelivery(event) {
        var valueIVADelivery = $('#delivery-address input[name="vat_number"]').val();
        var patternIVADelivery = new RegExp(/^[A-Za-z]{2}\d/i);
        if(patternIVADelivery.test(valueIVADelivery)){
            $('#delivery-address input[name="vat_number"]').removeClass('border').removeClass('border-danger');
            errorIVADelivery=0;
        }else{
            alert("PARTIVA IVA NON CORRRETTA - Inserire la Partita IVA con il seguente formato: IT00000000000");
            $('#delivery-address input[name="vat_number"]').addClass('border border-danger');
            errorIVADelivery=1;
        }
        if(errorIVADelivery || errorSDIDelivery){
            $('#delivery-address .address-form .form-submit').prop('disabled',true);
            $('#delivery-address .form-submit').prop('disabled',true);
        }else{
            $('#delivery-address .address-form .form-submit').prop('disabled',false);
            $('#delivery-address .form-submit').prop('disabled',false);
        }
     }

     /* Check SDI - ACCOUNT */
     function checkSDIAccount(event) {
        var valueSDIAccount = $('body#address input[name="address2"]').val();
        var patternSDIAccount = new RegExp(/^[A-Za-z0-9]{7}/g);
        if(patternSDIAccount.test(valueSDIAccount)){
            $('body#address input[name="address2"]').removeClass('border').removeClass('border-danger');
            errorSDIAccount=0;
        }else{
            alert("CAMPO SDI NON CORRRETTO");
            $('body#address input[name="address2"]').addClass('border border-danger');
            errorSDIAccount=1;
        }
        if(errorIVAAccount || errorSDIAccount){
            $('body#address .address-form .form-submit').prop('disabled',true);
            $('body#address .form-submit').prop('disabled',true);
        }else{
            $('body#address .address-form .form-submit').prop('disabled',false);
            $('body#address .form-submit').prop('disabled',false);
        }
     }

     /* Check SDI - INDIRIZZO FATTURAZIONE */
     function checkSDIInvoice(event) {
        var valueSDIInvoice = $('#invoice-address input[name="address2"]').val();
        console.log(valueSDIInvoice);
        var patternSDIInvoice = new RegExp(/^[A-Za-z0-9]{7}/g);
        if(patternSDIInvoice.test(valueSDIInvoice)){
            $('#invoice-address input[name="address2"]').removeClass('border').removeClass('border-danger');
            errorSDIInvoice=0;
        }else{
            alert("CAMPO SDI NON CORRRETTO");
            $('#invoice-address input[name="address2"]').addClass('border border-danger');
            errorSDIInvoice=1;
        }
        if(errorIVAInvoice || errorSDIInvoice){
            $('#invoice-address .address-form .form-submit').prop('disabled',true);
            $('#invoice-address .form-submit').prop('disabled',true);
        }else{
            $('#invoice-address .address-form .form-submit').prop('disabled',false);
            $('#invoice-address .form-submit').prop('disabled',false);
        }
     }

     /* Check SDI - INDIRIZZO SPEDIZIONE */
     function checkSDIDelivery(event) {
        var valueSDIDelivery = $('#delivery-address input[name="address2"]').val();
        var patternSDIDelivery = new RegExp(/^[A-Za-z0-9]{7}/g);
        if(patternSDIDelivery.test(valueSDIDelivery)){
            $('#delivery-address input[name="address2"]').removeClass('border').removeClass('border-danger');
            errorSDIDelivery=0;
        }else{
            alert("CAMPO SDI NON CORRRETTO");
            $('#delivery-address input[name="address2"]').addClass('border border-danger');
            errorSDIDelivery=1;
        }
        if(errorIVADelivery || errorSDIDelivery){
            $('#delivery-address .address-form .form-submit').prop('disabled',true);
            $('#delivery-address .form-submit').prop('disabled',true);
        }else{
            $('#delivery-address .address-form .form-submit').prop('disabled',false);
            $('#delivery-address .form-submit').prop('disabled',false);
        }
     }

     function onlyNumber(event) {
        var value = String.fromCharCode(event.which);
        var pattern = new RegExp(/^[0-9]/i);
        return pattern.test(value);
     }
     /* Check Partita IVA e SDI area privata utente */
     $('body#address input[name="vat_number"]').bind('blur', partitaIVAAccount);     

     /* Check Partita IVA carrello */
     $('#invoice-address input[name="vat_number"]').bind('blur', partitaIVAInvoice);     
     $('#delivery-address input[name="vat_number"]').bind('blur', partitaIVADelivery);     

     $('input[name="phone"]').bind('keypress', onlyNumber);     
     $('input[name="phone_mobile"]').bind('keypress', onlyNumber);   

     /* Stato iniziale scelta SDI o PEC */
     function startSDIPECValue(){
        var sdiStartValue=$('input[name="address2"]').val();     
        var pecStartValue=$('input[name="dni"]').val();
   
        if( (sdiStartValue=="" && pecStartValue=="") || sdiStartValue!=""){
           $('#sdi-radio').prop('checked',true);           
           $("label[for='SDI']").append('<b class="req"> *</b>');
           $('input[name="address2"]').prop('required',true);           

           $("label[for='PEC'] .req").remove();
           $('input[name="dni"]').prop('required',false);           
           $('input[name="dni"]').prop('disabled',true);           

           $('#invoice-address input[name="address2"]').bind('blur', checkSDIInvoice);
           $('#delivery-address input[name="address2"]').bind('blur', checkSDIDelivery);
           $('body#address input[name="address2"]').bind('blur', checkSDIAccount);
        }
        if( pecStartValue!=""){
            $('#sdi-radio').prop('checked',false);           
            $('#pec-radio').prop('checked',true);           
            $("label[for='PEC']").append('<b class="req"> *</b>');
            $('input[name="dni"]').prop('required',true);           
 
            $("label[for='SDI'] .req").remove();
            $('input[name="address2"]').prop('required',false);           
            $('input[name="address2"]').prop('disabled',true);           
        }
     }
     startSDIPECValue();

     /* Check SDI o PEC */
     $('body').on('change','input[name="sdi-pec-scelta"]',function(){
        if($(this).data('value')=="SDI"){
            $('input[name="address2"]').prop('disabled',false);
            $("label[for='SDI']").append('<b class="req"> *</b>');
            $('input[name="address2"]').prop('required',true);            
             /* Check SDI carrello */
            $('#invoice-address input[name="address2"]').bind('blur', checkSDIInvoice);
            $('#delivery-address input[name="address2"]').bind('blur', checkSDIDelivery);
            $('body#address input[name="address2"]').bind('blur', checkSDIAccount);

            $('input[name="dni"]').prop('disabled',true);
            $("label[for='PEC'] .req").remove();
            $('input[name="dni"]').prop('required',false);            
            $('input[name="dni"]').val('');            
        }else{
            $("label[for='SDI'] .req").remove();
            $('input[name="address2"]').prop('disabled',true);
            $('input[name="address2"]').prop('required',false);            
            $('input[name="address2"]').val('');            

            $('input[name="dni"]').prop('disabled',false);
            $("label[for='PEC']").append('<b class="req"> *</b>');
            $('input[name="dni"]').prop('required',true);            

            /* Check SDI carrello */
            $('input[name="address2"]').removeClass('border').removeClass('border-danger');
            $('.address-form .form-submit').prop('disabled',false);
            $('.form-submit').prop('disabled',false);
            $('input[name="address2"]').unbind('blur', checkSDIInvoice);
            $('input[name="address2"]').unbind('blur', checkSDIDelivery);
            $('input[name="address2"]').bind('blur', checkSDIAccount);
        }
     });

    // identifica solo la pagina di registrazione fuori dal carrello!!!!!
    if($('body#authentication #customer-form').length==1){
        $('body#authentication').addClass('registration-page');
    }
    if($('body#authentication .login-form').length==1){
        $('body#authentication').addClass('registration-page');
    }

    // Non osare registrarti se non sei un'azienda o un privato!
     $('#customer-form .form-submit').click(function(e){
        e.preventDefault();
        if($('#customer-form input[name=id_gender]:checked').length==0){
            alert("Attenzione, per poter proseguire nella registrazione è necessario selezionare un Titolo Sociale");
        }
        else{
            $('#customer-form').submit();
        }
    });

    // Acquista online versione mobile
    var windowWidthAO=$(window).width();
    if(windowWidthAO<=767){
        $(window).scroll(function(){
            if($(window).scrollTop()>40){
                $('#buy-online-mobile').addClass('fixed');
                $('#buy-online-mobile').animate({'top':'0px'},300);
            }else{
                $('#buy-online-mobile').removeClass('fixed');
                $('#buy-online-mobile').animate({'top':'-100px'},300);
            }
        });
    }

    // Immagine slider versione mobile
    if($(window).width()<768){
        $('#homeslider img.home-slider-image').attr('src','/img/cms/slide-home-responsive-767_1.jpg');
    }

    // Sticchio menù - mission impossible
    var windowWidth=$(window).width();
    $('#header').addClass('fixed sticky');
    if($(window).width()<767){
        $('body').addClass('mobile');
    }
    $(window).scroll(function(){
        if($(window).scrollTop()>40){
            if($(window).width()<767){
                $('#buy-online-mobile').stop(true,true).slideUp();
            }
            $('body#index .bg-nav-grey,body#cms .bg-nav-grey').addClass('darken');
            $('#ps_linklist a').css({'font-size':'0.775rem'});
            $('#green-number').css({'font-size':'0.96rem'});
            $('#custom-categories .row > div h4').css({'font-size':'1.11rem'});
            $('#custom-categories').css({'padding-top':'0.8rem'});
            $('#custom-categories').css({'padding-bottom':'0.8rem'});
            $('#site-logo').addClass('sticky');
            $('#babbo-ben').addClass('sticky');
            $('#burger-menu').css({'font-size':'1.3rem'});
            if($(window).width()<767){
                $('#topbar-secondary .trustpilot-widget.header').css({'padding':'22px 0px 6px 0px'});
            }else{
                $('#topbar-secondary .trustpilot-widget.header').css({'padding':'10px 0px 6px 0px'});
            }
        }
        else{
            if($(window).width()<767){
                $('#buy-online-mobile').stop(true,true).slideDown();
            }
            $('body#index .bg-nav-grey,body#cms .bg-nav-grey').removeClass('darken');
            $('#ps_linklist a').css({'font-size':'0.875rem'});
            $('#green-number').css({'font-size':'1.06rem'});
            $('#custom-categories .row > div h4').css({'font-size':'1.31rem'});
            $('#custom-categories').css({'padding-top':'1.1rem'});
            $('#custom-categories').css({'padding-bottom':'1.1rem'});
            $('#site-logo').removeClass('sticky');
            $('#babbo-ben').removeClass('sticky');
            $('#burger-menu').css({'font-size':'1.6rem'});
            if($(window).width()<767){
                $('#topbar-secondary .trustpilot-widget.header').css({'padding':'22px 0px 9px 0px'});
            }else{
                $('#topbar-secondary .trustpilot-widget.header').css({'padding':'13px 0px 9px 0px'});
            }
        }
    })           

    // Che gran giramento di numeri
    function isVisible(elem){
        return $(elem).offset().top - $(window).scrollTop() < $(elem).height();
     }

     if($('body').attr('id')=='index'){
        $(window).scroll(function(){
            if (isVisible($('#successi-content'))){
                $('#successi-content #numbers h2').each(function(){
                    $(this).prop('Counter',0).animate({
                        Counter: $(this).data('final-count')
                    },
                    {
                       duration: 4000,
                       easing: 'swing',
                       step: function (now) {
                           now = Number(Math.ceil(now)).toLocaleString('it');
                           $(this).find('span').text(now);
                       }
                    });
                });
            }
         })
     }

     // Cambio campo data di nascita da type text in type date
     $('input[name="birthday"]').attr('type','date');

     // Nel campo città non si accettano numeri!
     function onlyChar(event) {
        var value = String.fromCharCode(event.which);
        var pattern = new RegExp(/[^0-9]/i);
        return pattern.test(value);
     }
     
     $('input[name="city"]').bind('keypress', onlyChar);     

     // Le checkbox che sembrano delle radio
     $("#multiple-address-section input[type='checkbox']").on('click', function() {
        $("#multiple-address-section input[type='checkbox']").prop("checked", false);
        $(this).prop("checked", true);
     });     

     // Il cerca che si vede e non si vede
     $('#search-toggle').click(function(){
        $('#search-bar-wrapper-inner').slideToggle();      
     })

     // Il wrapper delle tabs nella scheda prodotto che scompare!
     if($('body#product .product-tabs-content .tab-pane').length==0){
        $('body#product .product-tabs').remove();
     }

     // E la pagina torna su cliccando sulla paginazione della product list
     prestashop.on('updateProductList', () => {
        let target = $("#wrapper");
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 500);
        }
    });     

    // Non ordinare più di quanto c'è in magazzino, mai, mai più!
    $('input.qty-product-list').change(function(){
        var currentValue=parseInt($(this).val());
        var maxValue=parseInt($(this).attr('max'));
        if(currentValue>=maxValue){
            $(this).val(maxValue);
            $('#modal-out-stock .modal-body p').html('<b>Attenzione!</b><br>per questo prodotto sono disponibili massimo <b>'+maxValue+' articoli</b>.<br>Clicca su <b>Aggiungi al Carrello</b> per inserire nell\'ordine la quantità massima di <b>'+maxValue+'</b> articoli.');
            $('#modal-out-stock').modal('show');           
        }
        if(currentValue<=0){
            $(this).val(1);
        }
    })

    $('body#product #quantity_wanted').change(function(){
        var currentValue=parseInt($(this).val());
        var maxValue=parseInt($(this).attr('max'));
        if(currentValue>=maxValue){
            $(this).val(maxValue);
            $('#modal-out-stock .modal-body p').html('<b>Attenzione!</b><br>per questo prodotto sono disponibili massimo <b>'+maxValue+' articoli</b>.<br>Clicca su <b>Aggiungi al Carrello</b> per inserire nell\'ordine la quantità massima di <b>'+maxValue+'</b> articoli.');
            $('#modal-out-stock').modal('show');           
        }
        if(currentValue<=0){
            $(this).val(1);
        }
    })

    /* BLOCCA SELEZIONE SETTIMANA CONSEGNA - ELENCO ORDINI AREA RISERVATA UTENTE */
    $('body#order-detail #checkoutblock-wrapper select').prop('disabled',true);

});


// WEBPACK FOOTER //
// ./js/theme.js